import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@/shared-ui';
import { cn } from '@/lib/utils';

export interface LoadMoreProps {
    loadedCount: number;
    total: number;
    hasMore: boolean;
    isLoading: boolean;
    onLoadMore: () => void;
    className?: string;
}

export const LoadMore = ({ loadedCount, total, hasMore, isLoading, onLoadMore, className }: LoadMoreProps) => {
    const { t } = useTranslation('category');

    if (total <= 0) return null;

    return (
        <div data-slot="load-more" className={cn('flex flex-col items-center gap-4 text-center', className)}>
            <Typography data-slot="load-more-status" variant="p" className="font-light" aria-live="polite">
                {t('loadMore.status', {
                    loaded: loadedCount,
                    total,
                    defaultValue: "You've viewed {{loaded}} of {{total}} products",
                })}
            </Typography>

            {hasMore && (
                <Button
                    type="button"
                    variant="secondary"
                    className="text-sm min-w-[343px] tracking-[1.68px] h-12"
                    onClick={onLoadMore}
                    disabled={isLoading}
                    data-slot="load-more-button">
                    {t('loadMore.button', { defaultValue: 'Load more' })}
                </Button>
            )}
        </div>
    );
};
